import RemuneracaoMedicaApi from '@/Apis/RemuneracaoMedica/Services/RemuneracaoMedicaApi'
import EventBus from '@/plugins/EventBus'
import Vue from 'vue'
import { FontePagadoraAgrupamento, UseAgrupamentoState } from './types'
import { RequestOptionsProps } from '../types'

const useAgrupamento = (() => {
  const state = Vue.observable<UseAgrupamentoState>({
    fetchedFontesPagadoras: false,
    fontesPagadoras: [],
  })

  // A personificacao troca o usuario sem reload: sem zerar, o menu e as telas
  // usariam as fontes pagadoras do operador.
  function reset() {
    state.fetchedFontesPagadoras = false
    state.fontesPagadoras = []
  }

  async function loadFontesPagadoras({
    forceRefresh = false,
    showToastError = false,
  }: RequestOptionsProps = {}) {
    if (state.fetchedFontesPagadoras && !forceRefresh) {
      return { success: true, data: state.fontesPagadoras }
    }

    const response = await RemuneracaoMedicaApi.getFontePagadoraAll()

    if (response.success) {
      state.fontesPagadoras = response.data as FontePagadoraAgrupamento[]
      state.fetchedFontesPagadoras = true
    } else if (showToastError) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Não foi possível carregar as fontes pagadoras.',
        icon: 'warning',
        color: '#C62828',
      })
    }

    return response
  }

  return {
    get fontesPagadoras() {
      return state.fontesPagadoras
    },
    get possuiHospitalComAgrupamentoAtivo() {
      return state.fontesPagadoras.some(fonte => fonte.geraAgrupamento)
    },
    loadFontesPagadoras,
    reset,
  }
})()

export default useAgrupamento
